module.exports = __webpack_public_path__ + "static/media/phone.3d346b3f.svg";